import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[argomento-validator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: ArgomentoValidatorDirective, multi: true }]
})
export class ArgomentoValidatorDirective  implements Validator {

  validate(c: FormControl): ValidationErrors {
    console.log('argomento-validator', c.value);
    const isValid = c.value && c.value.codice;
    const message = {
      'argomento': {
        'message': 'Specificare un argomento'
      }
    };
    return isValid ? null : message;
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/validators/argomento-validator.directive.ts